import React, { useState, useEffect } from "react";
import {
	Box,
	Button,
	Container,
	Paper,
	TextField,
	Typography,
	IconButton,
	InputAdornment,
	Snackbar,
	Alert,
	// Collapse,
	// Stack,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from "./AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

const LoginPage = () => {
	const [showPassword, setShowPassword] = useState(false);
	// const [showRegister, setShowRegister] = useState(false);
	const [errorOpen, setErrorOpen] = useState(false);

	const [emailOrPhone, setEmailOrPhone] = useState("");
	const [password, setPassword] = useState("");

	// const [registerDetails, setRegisterDetails] = useState({
	//   name: "",
	//   phone: "",
	//   email: "",
	//   password: "",
	// });

	const { login, user, userDetails } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		// Only redirect if user is authenticated AND currently on login page
		if (user && location.pathname === "/login") {
			// Check if there's a redirect destination in the URL
			const params = new URLSearchParams(location.search);
			const redirectTo = params.get("redirectTo");

			if (redirectTo) {
				// If there's a specific redirect destination, go there
				navigate(redirectTo);
			} else {
				// Otherwise, redirect based on admin_type
				if (userDetails && userDetails.data) {
					if (userDetails.data.admin_type === "superadmin") {
						navigate("/");
					} else {
						navigate("/");
					}
				} else {
					// If we don't have user details yet, redirect to dashboard as default
					navigate("/");
				}
			}
		}
	}, [user, userDetails, navigate, location]);

	// inside handleLogin
	const handleLogin = async (e) => {
		e.preventDefault();

		// Basic email regex
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const isEmail = emailRegex.test(emailOrPhone);

		const result = await login(
			emailOrPhone,
			password,
			isEmail ? "email" : "phone"
		);

		if (result.success) {
			// Check admin_type and redirect accordingly
			if (result.userDetails.data.admin_type.trim() === "superadmin") {
				navigate("/");
			} else {
				navigate("/");
			}
		} else {
			setErrorOpen(true);
		}
	};

	const handleCloseError = (_, reason) => {
		if (reason === "clickaway") return;
		setErrorOpen(false);
	};

	// const handleToggleForm = () => {
	//   setShowRegister((prev) => !prev);
	// };

	return (
		<Box
			sx={{
				minHeight: "100vh",
				background: "linear-gradient(135deg, #e0eafc, #cfdef3)",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				px: 2,
				fontFamily: "'Inter', sans-serif",
			}}
		>
			<Container maxWidth="sm">
				<Paper
					elevation={8}
					sx={{
						p: 5,
						borderRadius: "20px",
						backdropFilter: "blur(10px)",
						backgroundColor: "rgba(255, 255, 255, 0.85)",
						boxShadow: "0 12px 32px rgba(0,0,0,0.1)",
						transition: "all 0.3s ease",
					}}
				>
					<Typography
						variant="h4"
						align="center"
						gutterBottom
						sx={{ fontWeight: 600, color: "#1a202c" }}
					>
						Sign In
						{/* {showRegister ? "Register" : "Sign In"} */}
					</Typography>
					<Typography
						variant="subtitle2"
						align="center"
						gutterBottom
						sx={{ color: "#4a5568", mb: 3 }}
					>
						Access your IoT Dashboard
						{/* {showRegister
              ? "Create your new account"
              : "Access your IoT Dashboard"} */}
					</Typography>

					{/* Login Form */}
					{/* <Collapse> */}
					{/* in={!showRegister}>*/}
					<Box component="form" onSubmit={handleLogin}>
						<TextField
							label="Phone / Email"
							variant="outlined"
							fullWidth
							margin="normal"
							value={emailOrPhone}
							onChange={(e) => setEmailOrPhone(e.target.value)}
							required
							InputProps={{ style: { borderRadius: 12 } }}
						/>
						<TextField
							label="Password"
							variant="outlined"
							fullWidth
							type={showPassword ? "text" : "password"}
							margin="normal"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							required
							InputProps={{
								style: { borderRadius: 12 },
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() =>
												setShowPassword((prev) => !prev)
											}
											edge="end"
										>
											{showPassword ? (
												<VisibilityOff />
											) : (
												<Visibility />
											)}
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
						<Button
							type="submit"
							variant="contained"
							fullWidth
							sx={{
								mt: 3,
								py: 1.5,
								borderRadius: "12px",
								fontWeight: "600",
								fontSize: "1rem",
								textTransform: "none",
								backgroundColor: "#2b6cb0",
								"&:hover": {
									backgroundColor: "#2c5282",
								},
							}}
						>
							Login
						</Button>
					</Box>
					{/* </Collapse> */}

					{/* Register Form */}
					{/* <Collapse in={showRegister}>
            <Box component="form" onSubmit={handleRegister}>
              <Stack spacing={2} mt={2}>
                <TextField
                  label="Full Name"
                  variant="outlined"
                  fullWidth
                  value={registerDetails.name}
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      name: e.target.value,
                    })
                  }
                  InputProps={{ style: { borderRadius: 12 } }}
                />
                <TextField
                  label="Phone"
                  variant="outlined"
                  fullWidth
                  value={registerDetails.phone}
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      phone: e.target.value,
                    })
                  }
                  InputProps={{ style: { borderRadius: 12 } }}
                />
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={registerDetails.email}
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      email: e.target.value,
                    })
                  }
                  InputProps={{ style: { borderRadius: 12 } }}
                />
                <TextField
                  label="Set Password"
                  variant="outlined"
                  fullWidth
                  type="password"
                  value={registerDetails.password}
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      password: e.target.value,
                    })
                  }
                  InputProps={{ style: { borderRadius: 12 } }}
                />

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    py: 1.5,
                    borderRadius: "12px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    textTransform: "none",
                    backgroundColor: "#38a169",
                    "&:hover": {
                      backgroundColor: "#2f855a",
                    },
                  }}
                >
                  Register
                </Button>
              </Stack>
            </Box>
          </Collapse> */}

					{/* Toggle Form Button */}
					{/* <Button
            fullWidth
            onClick={handleToggleForm}
            sx={{
              mt: 2,
              py: 1.2,
              borderRadius: "12px",
              fontWeight: 500,
              textTransform: "none",
              color: "#2b6cb0",
              "&:hover": {
                backgroundColor: "#ebf8ff",
              },
            }}
          >
            {showRegister ? "Back to Login" : "Register"}
          </Button> */}
				</Paper>

				{/* Error Snackbar */}
				<Snackbar
					open={errorOpen}
					autoHideDuration={4000}
					onClose={handleCloseError}
					anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
				>
					<Alert
						severity="error"
						onClose={handleCloseError}
						sx={{ width: "100%" }}
					>
						Incorrect credentials!
					</Alert>
				</Snackbar>
			</Container>
		</Box>
	);
};

export default LoginPage;
